// In-memory fallback when sessionStorage or crypto is unavailable
let memorySeed: string | null = null;

export function getSessionSeed(): string {
  const key = "marketplace_sort_seed";
  try {
    let seed = sessionStorage.getItem(key);
    if (!seed) {
      seed = crypto.randomUUID();
      sessionStorage.setItem(key, seed);
    }
    return seed;
  } catch {
    if (!memorySeed) {
      try {
        memorySeed = crypto.randomUUID();
      } catch {
        memorySeed = Math.random().toString(36).slice(2);
      }
    }
    return memorySeed;
  }
}
